const ACTIVE_FAB_BUTTONS = 'active-fab-buttons'
export enum FabButton {
  CREATE_ROOM = 'create-room',
  TOOLBOX = 'toolbox',
  STATIC_WAPPS = 'static-wapps',
}

const activeFabButtons = (() => {
  const localFabButtons = localStorage.getItem(ACTIVE_FAB_BUTTONS)
  if (localFabButtons) {
    return localFabButtons.split(',') as FabButton[]
  }
  return [FabButton.CREATE_ROOM, FabButton.TOOLBOX, FabButton.STATIC_WAPPS]
})()

export function shouldShowFabButton(types: FabButton[]) {
  const result: Boolean[] = types.map(() => false)
  activeFabButtons.forEach(button => {
    const index = types.findIndex(type => type === button)
    if (index !== -1) {
      result[index] = true
    }
  })
  return result
}
